fetch("/pages/swatches")
  .then(function (response) {
    return response.text();
  })
  .then(function (response) {
    const parser = new DOMParser();
    const parsed = parser.parseFromString(response, "text/html");

    let allSwatches = [];

    const swatchScripts = parsed.querySelectorAll('[id^="colorSwatchesJson"]');
    swatchScripts.forEach(function (script) {
      const swatches = JSON.parse(script.innerHTML);
      allSwatches = allSwatches.concat(swatches);
    });

    // Proceed with allSwatches array
    var style = document.createElement("style");
    style.innerHTML = "";

    allSwatches.forEach(function (element) {
      let className =
        ".swatch_color_" +
        element.title
          .toLowerCase()
          .replace(/[^a-z0-9]+/g, "-")
          .replace(/-$/, "")
          .replace(/^-/, "");
      style.innerHTML += className + "{";
      if (element.color) {
        style.innerHTML += "background-color: " + element.color + "; ";
      }
      if (element.image) {
        style.innerHTML +=
          "background: url(" +
          element.image +
          ") no-repeat center center;background-size: contain;";
      }
      style.innerHTML += " } ";

      if (element.color) {
        let className2 =
          ".svg_swatch_color_" +
          element.title
            .toLowerCase()
            .replace(/[^a-z0-9]+/g, "-")
            .replace(/-$/, "")
            .replace(/^-/, "");
        style.innerHTML += className2 + "{ color: " + element.color + " } ";
      }
    });
    document.head.appendChild(style);
  })
  .catch(function (err) {
    // There was an error
    console.warn("Something went wrong.", err);
  });

/* fetch('/pages/swatches').then(function (response) {
		return response.text();
	}).then(function (response) {
		const parser = new DOMParser();
		const parsed = parser.parseFromString(response, 'text/html');
		const swatches = JSON.parse(parsed.querySelector('#colorSwatchesJson').innerHTML);
		var style = document.createElement('style');
		style.innerHTML = '';
		swatches.forEach(element => {
			let className = '.swatch_color_' + element.title.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
			style.innerHTML += className + '{';
			if (element.color) {
				style.innerHTML += 'background-color: ' + element.color + '; ';
			}
			if (element.image) {
				style.innerHTML += 'background: url(' + element.image + ') no-repeat center center;background-size: contain;';

			}
			style.innerHTML += ' } ';

			if (element.color) {
				let className2 = '.svg_swatch_color_' + element.title.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
				style.innerHTML += className2 + '{ color: ' + element.color + ' } ';
			}
		});
		document.head.appendChild(style)
	}).catch(function (err) {
		// There was an error
		console.warn('Something went wrong.', err);
	}); */
